export default "__VITE_ASSET__CVsspzBr__"